/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { useFetchInboundMessages } from 'hooks';
import Message from './Message';
import Styles from './styles';
import useChatListTabSwitching from './useChatListTabSwitching';

const useStyles = makeStyles(Styles);

function ChatListInboundMessages({ onSelectConversation, selectedConversationId }) {
  const classes = useStyles();
  const { t } = useTranslation('labels');
  const { data: messages, hasNextPage, fetchNextPage, isLoading, total } = useFetchInboundMessages();

  useChatListTabSwitching(messages, onSelectConversation, selectedConversationId, 'active');

  return messages.length ? (
    <div className={classes.messagesWrapper} id="scrollable">
      <InfiniteScroll
        className={classes.scrollWrapper}
        dataLength={total}
        next={fetchNextPage}
        hasMore={hasNextPage}
        loader={<span className={classes.info}>{t('loading')}</span>}
        scrollableTarget="scrollable"
        endMessage={<span className={classes.info}>{t('you_have_seen_all_messages')}</span>}
      >
        {messages.map(({ attributes }) => (
          <Message
            isActive={attributes.conversationId === selectedConversationId}
            isRead={attributes.isRead}
            body={attributes.body}
            updatedAt={attributes.updatedAt}
            onSelectMessage={onSelectConversation(attributes.conversationId)}
            conversationId={attributes.conversationId}
            key={attributes.conversationId}
            participants={attributes.accounts}
          />
        ))}
      </InfiniteScroll>
    </div>
  ) : (
    <div className={classes.caption}>
      <Typography variant="subtitle1" component="span">
        {isLoading ? t('loading') : t('no_chats_available')}
      </Typography>
    </div>
  );
}

ChatListInboundMessages.propTypes = {
  selectedConversationId: PropTypes.string,
  onSelectConversation: PropTypes.func.isRequired,
};

ChatListInboundMessages.defaultProps = {
  selectedConversationId: null,
};

export default ChatListInboundMessages;
